module.exports = __webpack_public_path__ + "images/db7c53aae0a6f4481502eb5a6f57a6dd-IMG_5041a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_5041a.jpg
// module id = ./src/assets/images/slides/living/IMG_5041a.jpg
// module chunks = 0